import { Injectable } from "@angular/core"
import { CanActivate } from "@angular/router"
import { AdminUploadQueries } from "../pages/admin-upload/admin-upload.queries"
import { map } from "rxjs/operators"

@Injectable({providedIn: 'root'})
export class BulkUploaderGuard implements CanActivate {

  constructor( private queries: AdminUploadQueries ) {}

  canActivate() {
    return this.queries.guardQuery()
      .pipe(
        map( res => {
          return res.data.currentUser.adminImpersonating
        })
      )
  }
}
